import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  .section-header {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  h2 {
    font-size: clamp(2.6rem, 4vw, 3.2rem);
  }

  .eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.18rem;
    color: var(--muted);
    font-weight: 600;
    font-size: 1.2rem;
  }

  .muted {
    color: var(--muted);
  }

  .status {
    font-size: 1.5rem;
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1.6rem;
    margin-top: 0.4rem;
  }

  .project {
    padding: 2rem;
    background: var(--surface);
    border-radius: 18px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 14px 40px rgba(0, 0, 0, 0.3);
    }

    h3 {
      font-size: 2rem;
      letter-spacing: -0.02rem;
    }

    .description {
      color: var(--muted);
      font-size: 1.5rem;
      line-height: 1.6;
    }
  }

  .project-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .tag {
    padding: 0.6rem 1.2rem;
    border-radius: 999px;
    border: 1px solid var(--border);
    background: var(--pill-bg);
    font-weight: 700;
    font-size: 1.2rem;
    letter-spacing: 0.04rem;
  }

  .project-links {
    display: flex;
    align-items: center;
    gap: 0.8rem;

    a {
      width: 4rem;
      height: 4rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 1px solid var(--border);
      background: var(--pill-bg);
      transition: transform 0.2s ease, background 0.2s ease;

      &:hover {
        transform: translateY(-2px);
        background: var(--gradient);
      }

      img {
        width: 2rem;
      }
    }
  }

  .tech-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
  }

  .pill {
    border: 1px solid var(--border);
    border-radius: 999px;
    padding: 0.7rem 1.3rem;
    font-weight: 600;
    background: var(--pill-bg);
    color: var(--text);
    letter-spacing: 0.02rem;
  }

  @media (max-width: 640px) {
    .projects {
      gap: 1.2rem;
    }
  }
`
